
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ProgrammesHeroSection from './components/ProgrammesHeroSection';
import OccupationalCertificatesSection from './components/OccupationalCertificatesSection';
import LearnershipSection from './components/LearnershipSection';
import SkillsProgrammesSection from './components/SkillsProgrammesSection';
import ETDPProgrammesSection from './components/ETDPProgrammesSection';
import ProgrammesSidebar from './components/ProgrammesSidebar';

const pathways = [
  {
    icon: 'ri-award-line',
    title: 'Occupational Certificates',
    text: 'For recognised qualifications aligned to occupational roles and career progression.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Learnerships',
    text: 'Structured workplace learning that combines theory, practical work and assessment.',
  },
  {
    icon: 'ri-lightbulb-line',
    title: 'Skills Programmes',
    text: 'Focused short programmes for targeted upskilling and immediate workplace application.',
  },
];

export default function ProgrammesPage() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <ProgrammesHeroSection />
        <section className="section-wrap-sm bg-[#f8f9fa] border-b border-[#e8eaea]">
          <div className="section-inner">
            <div className="grid lg:grid-cols-[0.72fr_1.28fr] gap-10 items-start">
              <div>
                <p className="section-label">Find the right route</p>
                <h2 className="section-heading">Training options, made easier to compare</h2>
                <p className="section-body">
                  Start with the pathway that matches your organisation's goals, then use the programme list to compare levels, duration and focus areas.
                </p>
              </div>
              <div className="grid sm:grid-cols-3 gap-4">
                {pathways.map(pathway => (
                  <div key={pathway.title} className="card group p-5">
                    <div className="icon-box mb-4">
                      <i className={pathway.icon} />
                    </div>
                    <h3 className="font-sans text-sm font-semibold text-[#111111] mb-2">{pathway.title}</h3>
                    <p className="text-xs leading-relaxed text-[#6b7280]">{pathway.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
            <div className="lg:col-span-3">
              <OccupationalCertificatesSection />
              <LearnershipSection />
              <SkillsProgrammesSection />
              <ETDPProgrammesSection />
            </div>
            <div className="lg:col-span-1">
              <ProgrammesSidebar />
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
